import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  productName: {
    flex: 1,
    minWidth: 0,
  },
  numberCell: {
    width: 100,
    textAlign: "right",
  },
  content: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    minWidth: 0,
  },
  numbers: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
}));
